$(document).ready(function () {
    $(".rate-bar--list .rate-bar--item").bind("click", function (event) {
        event.preventDefault();
        updateReviewList($(this).data('reference'), $(this).data("note"));
        $("#rate-filter").val($(this).data("note"));
    });

    $("#rate-filter").on("change", function () {

        updateReviewList($(this).attr('data-reference'), this.value);
    });
});

function updateReviewList(reference,filtre) {
    $.ajax({
        type: "POST",
        url: '/product/GetReviews',
        data: {
            reference: reference,
            filtre: filtre 
        },
        success: function (data) {
            $('.modifjs').html(data);
            Foundation.libs.common.hidePreloader();
        },
        error: function () {
            Foundation.libs.common.hidePreloader();
        },
        beforeSend: function () {
            Foundation.libs.common.showPreloader();
        }
    });
}